import type { HouseholdInsightsApiResponse } from '../apiTypes.ts';

// Placeholder until the Household Insights endpoint exists — mirrors the guessed `HouseholdInsightsApiResponse` shape
export const mockHouseholdInsightsResponse: HouseholdInsightsApiResponse = {
  totals: {
    households: { value: 4_210_000, previous_value: 3_876_000 },
    users: { value: 8_720_000, previous_value: 7_546_000 },
    ctv_devices: { value: 5_120_000, previous_value: 4_817_000 },
  },
  household_size: [
    { bucket: '1-2', count: 1_640_000 },
    { bucket: '3-5', count: 1_370_000 },
    { bucket: '6+', count: 2_240_000 },
    { bucket: 'unknown', count: 410_000 },
  ],
  household_ctvs: [
    { bucket: '1-2', count: 1_640_000 },
    { bucket: '3-5', count: 1_400_000 },
    { bucket: '6+', count: 2_440_000 },
    { bucket: 'unknown', count: 500_000 },
  ],
  age_gender: [
    { age_bucket: '18-24', gender: 'male', count: 680_000 },
    { age_bucket: '18-24', gender: 'female', count: 1_190_000 },
    { age_bucket: '25-34', gender: 'male', count: 1_250_000 },
    { age_bucket: '25-34', gender: 'female', count: 1_400_000 },
    { age_bucket: '35-44', gender: 'male', count: 1_100_000 },
    { age_bucket: '35-44', gender: 'female', count: 1_050_000 },
    { age_bucket: '45-54', gender: 'male', count: 820_000 },
    { age_bucket: '45-54', gender: 'female', count: 900_000 },
    { age_bucket: '55-64', gender: 'male', count: 560_000 },
    { age_bucket: '55-64', gender: 'female', count: 600_000 },
    { age_bucket: '65+', gender: 'male', count: 380_000 },
    { age_bucket: '65+', gender: 'female', count: 470_000 },
    { age_bucket: 'unknown', gender: 'male', count: 300_000 },
    { age_bucket: 'unknown', gender: 'female', count: 310_000 },
    { age_bucket: '25-34', gender: 'unknown', count: 260_000 },
  ],
  household_profile: [
    { bucket: 'homeowners', count: 6_280_000 },
    { bucket: 'without_children', count: 4_120_000 },
    { bucket: 'adults', count: 5_940_000 },
    { bucket: 'college_educated', count: 2_870_000 },
    { bucket: 'rentals', count: 1_930_000 },
    { bucket: 'with_children', count: 2_160_000 },
    { bucket: 'below_bachelor', count: 3_410_000 },
    { bucket: 'young_adults', count: 1_010_000 },
  ],
  occupation_group: [
    { bucket: 'blue_collar', count: 1_840_000 },
    { bucket: 'farmer', count: 210_000 },
    { bucket: 'office_administration', count: 1_120_000 },
    { bucket: 'management', count: 960_000 },
    { bucket: 'sales', count: 1_350_000 },
    { bucket: 'technical', count: 870_000 },
    { bucket: 'professional', count: 1_580_000 },
    { bucket: 'retired', count: 1_270_000 },
    { bucket: 'others', count: 430_000 },
  ],
};
